const stepperData = ["届出待ち", "承認中", "完了"];

const headList: any[] = [
  {
    headTitle: "職員名",
  },
  {
    headTitle: "性別",
    align: "center",
  },
  {
    headTitle: "生年月日",
    align: "center",
  },
  {
    headTitle: "加入年月日",
    align: "center",
  },
  {
    headTitle: "雇用契約書の写し",
  },
];

export { stepperData, headList };
